import {Notifications, notifications} from '@mantine/notifications';
import Image from 'next/image';
import {MdContentCopy} from 'react-icons/md';
import {
  createLineShareUrl,
  createXShareUrl,
} from '../../../core/factories/shared/createShareUrl';
import {CommonLink} from '../CommonLink';

type Props = {
  opened: boolean;
  close: () => void;
  currentUrl: string;
  title: string;
};

export const ShareButtonMenu: React.FC<Props> = ({
  opened,
  close,
  currentUrl,
  title,
}) => {
  const services = [
    {
      name: 'X',
      icon: '/next-image/common/sns/X.svg',
      url: createXShareUrl({currentUrl, title}),
    },
    {
      name: 'LINE',
      icon: '/next-image/common/sns/LINE.svg',
      url: createLineShareUrl({currentUrl, title}),
    },
  ];
  const handleCopyClick = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      notifications.show({
        title: 'コピーしました',
        message: '',
        color: 'green',
      });
    } catch {
      notifications.show({
        title: 'コピーできませんでした。',
        message: '再度お試しください。',
        color: 'red',
      });
    }
  };

  return (
    opened && (
      <>
        <div
          className="h-svh w-svw fixed top-0 left-0 bg-transparent z-50"
          onClick={close}
        />
        <div className="bg-white p-4 shadow-modal w-[190px] rounded-4 absolute z-50">
          {services.map((service) => (
            <CommonLink
              key={service.url}
              className="flex items-center text-base leading px-12 w-full h-[38px] border-b-[1px] border-line border-collapse [&:nth-last-child(1)]:border-b-[0px] hover:opacity-80"
              href={service.url}
              target="_blank"
            >
              <Image
                src={service.icon}
                width={20}
                height={20}
                alt={`${service.name}でシェア`}
                className="mr-8"
              />
              <p className="text-base text-black-1 leading">{`${service.name}でシェア`}</p>
            </CommonLink>
          ))}
          <div
            className="flex items-center text-base leading px-12 w-full h-[38px] hover:opacity-80 cursor-pointer"
            onClick={async () => handleCopyClick(currentUrl)}
          >
            <MdContentCopy size={20} className="mr-8" />
            <p className="text-base text-black-1 leading">URLをコピー</p>
          </div>
        </div>
        <Notifications position={'top-right'} />
      </>
    )
  );
};
